import {version} from './version';

export const environment = {
    production: true,
    apiUrl: 'https://demo-api.oaportal.org/api',
    debug: true,
    logoImage: '/assets/img/openarms.png',
    title: 'Open Arms Home Care',
    client: 'openarms',
    mockRules: false,
    sentryDns: null,
    tracesSampleRate: 0.01,
    skipRelativeSelection: false,
    openFileInNewTab: true,
    echoKey: 'ec829a7d-897d-4f7a-b2f7-dfe68c4c2a8e',
    loginEndpoint: 'https://demo-api.oaportal.org/api/v2/broadcasting/auth',
    wsHost: 'dev.notification-service.myallamericancare.com',
    wsPort: '6001',
    wssPort: '6002',
    sessionPopupTimeout: 1620000,
    sessionTimeout: 1800000,
    ...version
};
